import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class GoogleMapsLoaderService {
  private static promise: Promise<void>;

  load(apiKey: string): Promise<void> {
    if (GoogleMapsLoaderService.promise == null) {
      GoogleMapsLoaderService.promise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = (error: any) => reject(error);
        document.body.appendChild(script);
      });
    }

    return GoogleMapsLoaderService.promise;
  }
}
